import { useEffect, useState, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { adminGet } from './adminApi';
import { toast } from 'sonner';
import { qrGet } from './qr/qrApi';
import { IssuePassportsForm } from './qr/IssuePassportsForm';
import { PassportBatchesTable } from './qr/PassportBatchesTable';
import { QrPassportsList } from './qr/QrPassportsList';
import AdminPassportsPage from './AdminPassportsPage';

const TABS = [['stock', 'Stock & batches'], ['journeys', 'Journeys']];

// Phase 7 Sale & supply → Issue passports: the only place passports are minted (QR Phase 1 issuance) + the legacy journey view as a tab.
export default function IssuePassportsPage() {
  const [params, setParams] = useSearchParams();
  const tab = params.get('tab') === 'journeys' ? 'journeys' : 'stock';
  const [customers, setCustomers] = useState([]);
  const [tenantId, setTenantId] = useState(params.get('customer') || '');
  const [profiles, setProfiles] = useState([]);
  const [batches, setBatches] = useState([]);
  const [batchId, setBatchId] = useState('');
  const customerName = customers.find(c => c.id === tenantId)?.name;

  const loadBatches = useCallback(() => {
    if (!tenantId) { setBatches([]); return; }
    qrGet(`/passport-batches?tenant_id=${tenantId}`).then(setBatches).catch(e => toast.error(e.message));
  }, [tenantId]);
  useEffect(() => {
    adminGet('/customers-lite').then(cs => { setCustomers(cs); setTenantId(t => t || cs[0]?.id || ''); }).catch(() => {});
    qrGet('/profiles').then(setProfiles).catch(() => {});
  }, []);
  useEffect(() => { setBatchId(''); loadBatches(); }, [loadBatches]);

  const setTab = (t) => { const n = new URLSearchParams(params); n.set('tab', t); setParams(n, { replace: true }); };

  return (
    <div className="p-8 max-w-7xl space-y-6" data-testid="issue-passports-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-4xl font-bold" style={{ color: '#1B1D1C' }}>Issue passports</h1>
          <p className="text-sm mt-1" style={{ color: '#6b7069' }}>Track0tic is the issuer of every passport. Each batch is a book; tenants receive, never mint.</p>
        </div>
        <div className="flex rounded-md border overflow-hidden" style={{ borderColor: '#D9D6CD' }} data-testid="issue-passports-tabs">
          {TABS.map(([k, l]) => (
            <button key={k} data-testid={`issue-passports-tab-${k}`} onClick={() => setTab(k)} className="px-4 h-9 text-sm font-medium"
              style={tab === k ? { background: '#0B6B55', color: 'white' } : { background: 'white', color: '#4b504a' }}>{l}</button>
          ))}
        </div>
      </div>

      {tab === 'journeys' ? <div className="-m-8 mt-0" data-testid="issue-passports-journeys"><AdminPassportsPage embedded /></div> : (
        <div className="rounded-lg border bg-white p-6 space-y-5" style={{ borderColor: '#E5E3DC' }} data-testid="passport-qr-card">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <h2 className="text-xl font-bold" style={{ color: '#1B1D1C' }}>Passport QR · on the product</h2>
            <div className="flex items-center gap-3">
              <span className="px-2.5 py-1 rounded text-xs" style={{ background: '#EFEDE6', color: '#6b7069' }}>Issued per customer · never expires</span>
              <select data-testid="qr-customer-select" value={tenantId} onChange={e => setTenantId(e.target.value)}
                className="h-9 rounded border px-3 text-sm bg-white min-w-[240px]" style={{ borderColor: '#D9D6CD' }}>
                <option value="">Pick a customer…</option>
                {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
          </div>
          {!tenantId ? (
            <p className="text-sm" style={{ color: '#6b7069' }} data-testid="passport-pick-customer">Pick a customer to issue passports and see the books already issued to them.</p>
          ) : (
            <>
              <IssuePassportsForm customers={customers} profiles={profiles} tenantId={tenantId} onIssued={(r) => { loadBatches(); setBatchId(r.batch_id); }} />
              <div className="flex items-center gap-3">
                <h3 className="text-base md:text-lg font-semibold mr-auto" style={{ color: '#1B1D1C' }}>Books issued to {customerName}</h3>
                {batchId && <button data-testid="qr-clear-batch" className="text-xs underline" style={{ color: '#6b7069' }} onClick={() => setBatchId('')}>show all passports</button>}
              </div>
              <PassportBatchesTable batches={batches} selectedId={batchId} tenantScoped onSelect={(id) => setBatchId(id === batchId ? '' : id)} />
              <QrPassportsList tenantId={tenantId} batchId={batchId} />
            </>
          )}
        </div>
      )}
    </div>
  );
}
